import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import useGlobalSearchVerticalTabHotels from 'components/SearchV2/Hooks/useGlobalSearchVerticalTabHotels'
import GlobalSearchContextProvider from 'contexts/GlobalSearch/GlobalSearchContextProvider'
import type { GlobalSearchAction } from 'contexts/GlobalSearch/GlobalSearchState'
import type GlobalSearchState from 'contexts/GlobalSearch/GlobalSearchState'
import { GlobalSearchStateActions } from 'contexts/GlobalSearch/GlobalSearchState'
import { SupportedDestinations, SUPPORTED_DESTINATION_IDS } from 'home/constants'
import { capitalise } from 'lib/string/stringUtils'
import { useEffect } from 'react'
import * as React from 'react'
import { useParams } from 'react-router-dom'
import { useIntl } from 'react-intl'

function MobileSearch() {
  const intl = useIntl()
  const globalSearchVerticalTabHotels = useGlobalSearchVerticalTabHotels()
  const { context, ContentComponent: SearchElement, onSearch } = globalSearchVerticalTabHotels

  const { destination: destinationParam } = useParams<'destination'>()
  const destination = (destinationParam as SupportedDestinations | undefined) ?? SupportedDestinations.BALI
  const destinationId = SUPPORTED_DESTINATION_IDS[destination]

  // sync search item
  useEffect(() => {
    const searchItem: App.SearchItem = {
      searchType: 'destination',
      value: destinationId,
      format: {
        mainText: capitalise(destination),
      },
    };
    (context.dispatch as React.Dispatch<GlobalSearchAction>)({ type: GlobalSearchStateActions.SET_SEARCH_ITEM, searchItem })
  },
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  [])

  return (
    <GlobalSearchContextProvider state={context.state as GlobalSearchState} dispatch={context.dispatch as React.Dispatch<GlobalSearchAction>}>
      <VerticalSpacer gap={12}>
        <SearchElement
          onSearch={onSearch}
          isInPage
          temporarySearchSubmitRef={globalSearchVerticalTabHotels.temporarySearchSubmitRef}
          updateSearchSessionId={globalSearchVerticalTabHotels.updateSearchSessionId}
        />
        <TextButton
          kind="primary"
          size="large"
          shape="square"
          fit="full-width"
          onClick={onSearch}
        >
          {intl.formatMessage({
            id: 'lco2GTjHxZKwhxqqXUDM',
            defaultMessage: 'Search',
            description: 'Button text for the search action in the main search form or search bar input',
          })}
        </TextButton>
      </VerticalSpacer>
    </GlobalSearchContextProvider>
  )
}

export default MobileSearch
